<div class="dropdown-toggle" role="button" dropdownPlacement="bottom-end" id="dropdownMenuLink" [dropdown]="content">
  <span class="icon-doc" aria-hidden="true"></span>
  <span>SMPP Session Guide</span>
</div>

<ng-template #content let-dropdown="dropdown">
  <div class="dropdown-menu">
    <div class="dropdown-header">
      <h3 class="dropdown-title">SMPP Session Guide</h3>
      <button (click)="dropdown.hide()" type="button" class="btn-close"></button>

      <div class="stepper-wrapper">
        <app-session-guide-steps [activeStep]="activeStep()" (stepClick)="onSessionGuideStepClick($event)" />
      </div>
    </div>
    <div class="dropdown-content">
      @if(isPickSessionTypeStepActive()) {
      <app-session-type-step [selectedSessionType]="selectedSessionType()" (serviceClick)="onSessionTypeSelected($event)" />
      } @else if (isSetupPlatformStepActive()) {
      <app-setup-platform-step [selectedSessionType]="selectedSessionType()" />
      } @else {
      <app-create-session-step [createSessionActiveStep]="createSessionActiveStep()" (stepClick)="onCreateSessionStepClick($event)" />
      }
    </div>

    <div class="dropdown-footer">
      <div class="action-buttons">
        <button (click)="onPrevStepClick()" [disabled]="isPrevStepButtonDisabled()" class="action-button">
          <i class="icon-arrow-left"></i>
        </button>
        <button (click)="onNextStepClick()" [disabled]="isNextStepButtonDisabled()" class="action-button">
          <i class="icon-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>
